export default {
    smartSearch: {
        syntaxHelper: '搜索帮助 >',
        sections: {
            ANCS: '[标]当前申请(专利权)人',
            AUTOCOMPLETE: '自动推荐',
            FIELD: '字段',
            HISTORY: '历史记录',
            KEYWORDS: '关键词',
            LOGIC: '逻辑词',
            keywordFields: '关键词字段',
            assigneeFields: '申请人字段',
            classificationNumberFields: '分类号字段',
            otherFields: '其他字段',
            SAMPLE: '样例',
            CASE_NATURE: '案件性质',
            TRIAL_GRADE: '诉讼审级',
            PLE_TYPE: '质押类型',
            PATENT_TYPE: '专利类型',
            AUTHORITY: '受理局',
            ANS_TYPE: '[标]原始申请(专利权)人类型',
            CASE_REGION: '案件地区',
            EXCLUSIVITY: '许可排他性',
            SIMPLE_LEGAL_STATUS: '简单法律状态',
            LEGAL_STATUS: '法律状态',
            LEGAL_EVENT: '法律事件',
            CITE_CATEGORY: '引用类别',
            OUTCOME_STATUS: '案件状态',
            ANCS_TYPE: '[标]当前申请(专利权)人类型',
            GOV: '政府利益',
            LICENSE: '专利许可',
            LITIGATION: '专利诉讼',
            PLEDGE: 'PLEDGE',
            REEXAMINVALID: 'REEXAMINVALID',
            SEP_SOURCE: 'SEP数据源',
            GNAME: '自定义申请人组',
            EPDS_LS: 'EP指定国家/地区法律状态',
            EPDS_SLS: 'EP指定国家/地区简单法律状态',
            ATC_VALUE: '委托代理机构专利',
            UP_STATUS: '欧洲统一法院状态',
            EFAM_STATUS: 'Patsnap同族状态',
        },
        keywordQueryTitle: '在当前光标位置后追加{keyword}的扩展词',
    },
};
